export default {
    url: '/by_purchases',
    template: require('./view.html'),
    reloadOnSearch: false,
    data: {
        priority: 901,
        title: 'By purchases',
        role: 'conversion_rate',
    },
    controller: [
        '$scope',
        '$location',
        'conversion_rate_api',
        'chartFilters',
        function($scope, $location, conversion_rate_api, chartFilters) {
            $scope.purchases_data = {};
            $scope.ranges = {};
            $scope.gradient_colors = [
                '#ecf8ff',
                '#E6F5FF',
                '#DBF0FF',
                '#D1ECFF',
                '#C7E8FF',
                '#BDE4FF',
                '#B3E0FF',
                '#A8DCFF',
                '#9ED8FF',
                '#94D4FF',
                '#8AD0FF',
                '#80CCFF',
                '#78c4ff',
            ];
            $scope.update_purchase_conversion_rate_table = function(model) {
                conversion_rate_api.data_by_purchases(model).then(function(resp) {
                    $scope.purchases_data = resp;
                    $scope.calculate_ranges();
                });
            };
            $scope.calculate_ranges = function() {
                const data_keys = Object.keys($scope.purchases_data[0]);
                for (let key_i = 0; key_i < data_keys.length; key_i++) {
                    let values_list = [];
                    for (let i = 0; i < $scope.purchases_data.length; i++) {
                        values_list.push($scope.purchases_data[i][data_keys[key_i]]);
                    }
                    if (data_keys[key_i] === 'date' || data_keys[key_i] === 'installs') continue;
                    $scope.ranges[data_keys[key_i]] = {
                        min: Math.min.apply(Math, values_list),
                        max: Math.max.apply(Math, values_list),
                    };
                    $scope.ranges[data_keys[key_i]]['step'] =
                        ($scope.ranges[data_keys[key_i]]['max'] - $scope.ranges[data_keys[key_i]]['min']) /
                        ($scope.gradient_colors.length - 1);
                }
            };
            $scope.apply_purchase_color = function(value, key) {
                if (value !== 0) {
                    let position = Math.floor(
                        (value - $scope.ranges[key]['min']) / $scope.ranges[key]['step'],
                    );
                    return $scope.gradient_colors[position];
                }
            };
            $scope.apply_purchase_value = function(value) {
                return value !== 0 ? value : '-';
            };
            chartFilters.onChangeChartParams(
                'update_purchase_conversion_rate_table',
                $scope.update_purchase_conversion_rate_table,
            );
            $scope.update_purchase_conversion_rate_table(chartFilters.get_chart_filters());
        },
    ],
};
